import { render, staticRenderFns } from "./FieldObject.vue?vue&type=template&id=38675212&"
import script from "./FieldObject.vue?vue&type=script&lang=js&"
export * from "./FieldObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports